import React from 'react';
import { Pitch } from './Pitch';
import { FeedbackSlide } from '../components/deck/slides/FeedbackSlide';
import { SnakkerfySlide } from '../components/deck/slides/SnakkerfySlide';
import { UseCasesSlide } from '../components/deck/slides/UseCasesSlide';
import { ChannelsSlide } from '../components/deck/slides/ChannelsSlide';
import { JourneySlide } from '../components/deck/slides/JourneySlide';
import { SignalsSlide } from '../components/deck/slides/SignalsSlide';
import { CampaignSlide } from '../components/deck/slides/CampaignSlide';
import { CompoundSlide } from '../components/deck/slides/CompoundSlide';
import { StationSlide } from '../components/deck/slides/StationSlide';
import { DeckNav } from '../components/deck/DeckNav';
import { useActiveSection } from '../hooks/useActiveSection';
import { deckPages } from '../data/deck';
interface PresentationProps {
  showProgress: boolean;
  autoplayInterlude: boolean;
}

/** Meet the Filteks — From creative idea to commercial impact. */
export function Presentation({
  showProgress,
  autoplayInterlude
}: PresentationProps) {
  const active = useActiveSection(deckPages.map(page => page.id));
  return <div className="w-full bg-[#F7F5F0]" data-id="element-971" data-mp="wcnwclhiig1t">
      <section id="opening" aria-label="Meet the Filteks" className="snap-start" data-id="element-972" data-mp="11dbjux6j8era">
        <Pitch showProgress={showProgress} autoplayInterlude={autoplayInterlude} data-id="element-973" data-mp="164a2w4iwnqy8" />
      </section>
      <FeedbackSlide data-id="element-974" data-mp="1b3mybdnue6cf" />
      <JourneySlide data-id="element-975" data-mp="1b4elq17acxrm" />
      <SnakkerfySlide data-id="element-976" data-mp="1b2v529hpwkpb" />
      <ChannelsSlide data-id="element-977" data-mp="1b5pp3zwtk3i7" />
      <UseCasesSlide data-id="element-978" data-mp="1f587anx9a0hc" />
      <SignalsSlide data-id="element-979" data-mp="1f4oz3yxeqqgi" />
      <CompoundSlide data-id="element-980" data-mp="1f3x52sjgl0sc" />
      <StationSlide data-id="element-981" data-mp="1f3f2zfa47sci" />
      <CampaignSlide data-id="element-982" data-mp="1f72t04gcpwmh" />
      <DeckNav active={active} data-id="element-983" data-mp="1k3tbszjjj6bl" />
    </div>;
}